module.exports = __webpack_public_path__ + "images/88258a21884a4795a002de5c54af2e12.jpg";